import * as z from 'zod';

export const sentryReactConfigSchema = z.object({
  dsn: z.string().nonempty(),
  environment: z.string().nonempty(),
});

export type SentryReactConfig = z.infer<typeof sentryReactConfigSchema>;

export const sentryReactConfig = sentryReactConfigSchema.parse({
  dsn: z.string().nonempty().parse(import.meta.env.APP_CLIENT_WEB_SENTRY_DSN),
  environment: z
    .string()
    .nonempty()
    .parse(import.meta.env.APP_CLIENT_WEB_SENTRY_ENVIRONMENT),
});
